// RaviSoll Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu toggle ----
  var menuToggle = document.getElementById('menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // ---- Cart count update ----
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function () {});
  }
  updateCartCount();

  // ---- Toast feedback ----
  function showToast(message) {
    var toast = document.getElementById('ravisoll-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ravisoll-toast';
      toast.className = 'ravisoll-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('show');
    }, 2500);
  }

  // ---- Generic AJAX add-to-cart (product page + product cards) ----
  function bindAddToCart(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) {
        btn.dataset.original = original;
        btn.textContent = 'Wordt toegevoegd...';
        btn.disabled = true;
      }
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
        .then(function (res) {
          if (!res.ok) { throw new Error('add failed'); }
          return res.json();
        })
        .then(function () {
          updateCartCount();
          showToast('✓ Toegevoegd aan winkelwagen');
          if (btn) {
            btn.textContent = '✓ Toegevoegd!';
            setTimeout(function () {
              btn.textContent = btn.dataset.original || original;
              btn.disabled = false;
            }, 2000);
          }
        })
        .catch(function () {
          showToast('Er ging iets mis, probeer opnieuw');
          if (btn) {
            btn.textContent = btn.dataset.original || original;
            btn.disabled = false;
          }
        });
    });
  }

  document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(bindAddToCart);

  // ---- Live variant price + id update on product page ----
  var variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var btn = document.querySelector('#product-form .btn--add-cart');
      if (opt && opt.disabled && btn) {
        btn.textContent = 'Uitverkocht';
        btn.disabled = true;
      } else if (btn) {
        btn.textContent = 'In winkelwagen';
        btn.disabled = false;
      }
    });
  }

  // ---- Cart page: live quantity update ----
  window.updateQty = function (key, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  };

  // ---- Sticky header shadow ----
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(26,20,16,0.12)';
      } else {
        header.style.boxShadow = '0 1px 0 #E8DDD3';
      }
    });
  }

});
